function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { useEventTracker } from '@applyboard/ui-utils';
import { Box } from '@applyboard/ui-components';
import dropzoneEnhancer from "../../enhancers/dropzoneEnhancer";
import HtmlEditor from "../../HtmlEditor";
import SimpleButton from "../../core/button/SimpleButton";
import TextInput from "../../core/input/TextInput";
import InputCheckbox from "../../core/input_v2/InputCheckbox";
import ProgressBar from "../../core/ui/ProgressBar";
import UploadButton from "../../core/button/UploadButton";
import DropzoneOverlay from "../../core/ui/DropzoneOverlay";
import FileListing from "./Files/FileListing";
import NoteTemplateButton from "./NoteTemplateButton";
import { CheckboxWrapper, DisableOnLoading, HtmlEditorWrapper, NewNoteWrapper } from "../styles";
import Flex from "../../core/ui/flex";
import { useInitialProps } from "../../../hooks/useInitialProps";
var BUTTON_WIDTH = '70px';
var BUTTON_HEIGHT = '35px';
var isCancelled = false;
var NewNote = function NewNote(_ref) {
  var advancedEditor = _ref.advancedEditor,
    createPrivateNoteFromTemplate = _ref.createPrivateNoteFromTemplate,
    createPublicNoteFromTemplate = _ref.createPublicNoteFromTemplate,
    showNoteTemplates = _ref.showNoteTemplates,
    viewRestrictedNote = _ref.viewRestrictedNote,
    agentId = _ref.agentId,
    dropzoneDragging = _ref.dropzoneDragging,
    dropzoneHovering = _ref.dropzoneHovering,
    newNoteLoading = _ref.newNoteLoading,
    note = _ref.note,
    onCancel = _ref.onCancel,
    onCreateFromTemplate = _ref.onCreateFromTemplate,
    addFile = _ref.addFile,
    onSave = _ref.onSave,
    onChangeHandler = _ref.onChangeHandler,
    removeFile = _ref.removeFile,
    quill = _ref.quill,
    setQuill = _ref.setQuill,
    userPermissions = _ref.userPermissions,
    isAgencyAdminComments = _ref.isAgencyAdminComments,
    onRemoveFile = _ref.onRemoveFile,
    setNote = _ref.setNote,
    _ref$emptyNote = _ref.emptyNote,
    emptyNote = _ref$emptyNote === void 0 ? {
      title: null,
      body: '',
      visibility: 'public',
      dirty: false,
      template: null
    } : _ref$emptyNote;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var _useEventTracker = useEventTracker({
      data: {
        applicationStage: application === null || application === void 0 ? void 0 : application.current_stage
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  var canCreateNote = note && (note.visibility === 'public' && createPublicNoteFromTemplate || note.visibility === 'private' && createPrivateNoteFromTemplate);
  var shouldShowTemplateButton = showNoteTemplates && (agentId || canCreateNote);
  var quillSetSelection = function quillSetSelection(range) {
    setNote({
      dirty: true
    });
    quill === null || quill === void 0 ? void 0 : quill.setSelection(range, 0, 'api');
  };
  var handleOnSave = function handleOnSave(event) {
    if (event) event.stopPropagation();
    trackEvent({
      event: 'RP Profile - Admin Comments - Posted Admin Comment'
    });
    if (onChangeHandler) {
      onChangeHandler(note);
    }
    onSave().then(function () {
      if (onChangeHandler) {
        onChangeHandler(emptyNote);
      }
      setNote(emptyNote);
    });
  };
  var handleOnFiles = function handleOnFiles(event) {
    if (onChangeHandler) {
      onChangeHandler(note);
    }
    var files = event.target.files;
    files.forEach(function (file) {
      return addFile(file);
    });
  };
  var handleOnCancel = function handleOnCancel(event) {
    if (event) event === null || event === void 0 ? void 0 : event.stopPropagation();
    isCancelled = true;
    onCancel();
    setNote({
      dirty: false
    });
  };
  useEffect(function () {
    return function () {
      if (!isCancelled && onChangeHandler) onChangeHandler();
      isCancelled = false;
    };
  }, []);
  useEffect(function () {
    if (note && !note.dirty && quill && quillSetSelection) {
      var _quill$getLength;
      var range = (_quill$getLength = quill === null || quill === void 0 ? void 0 : quill.getLength()) !== null && _quill$getLength !== void 0 ? _quill$getLength : 0;
      var position = range || 0;
      if (position && position > 1) {
        quillSetSelection(range);
      }
    }
  }, [note]);
  return /*#__PURE__*/React.createElement(NewNoteWrapper, null, /*#__PURE__*/React.createElement(DisableOnLoading, null, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, shouldShowTemplateButton && /*#__PURE__*/React.createElement(NoteTemplateButton, {
    onCreateFromTemplate: onCreateFromTemplate,
    note: note,
    onClearTemplate: function onClearTemplate() {
      return setNote({
        title: '',
        body: '',
        template: null
      });
    }
  })), /*#__PURE__*/React.createElement(TextInput, {
    borderColor: "transparent",
    inputId: "title",
    inputValue: note.title,
    noPadding: true,
    onChange: function onChange(e) {
      return setNote({
        title: e.target.value
      });
    },
    placeholder: "Enter title here...",
    "aria-label": "Note input title"
  }), /*#__PURE__*/React.createElement(HtmlEditorWrapper, {
    "data-testId": "html-editor"
  }, /*#__PURE__*/React.createElement(HtmlEditor, {
    name: "body",
    onChange: function onChange(body) {
      return setNote({
        body: body
      });
    },
    quillRef: setQuill,
    sourceEditor: advancedEditor,
    value: note.body
  }))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    pb: 0.5
  }, /*#__PURE__*/React.createElement(CheckboxWrapper, null, (note === null || note === void 0 ? void 0 : note.visibility) === 'public' && createPublicNoteFromTemplate && showNoteTemplates && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.filter_note_template) && agentId && /*#__PURE__*/React.createElement(InputCheckbox, {
    name: "email_user",
    id: "email_user",
    labelText: "Email Recruitment Partner",
    checked: note.email_user,
    onChange: function onChange(e) {
      return setNote({
        email_user: e.target.checked
      });
    }
  }), viewRestrictedNote && (note === null || note === void 0 ? void 0 : note.visibility) === 'public' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputCheckbox, {
    name: "restricted",
    id: "restricted",
    labelText: "Private Note",
    checked: note.restricted,
    onChange: function onChange(e) {
      return setNote({
        restricted: e.target.checked
      });
    }
  }), /*#__PURE__*/React.createElement("span", {
    "data-for": "restricted-note",
    "data-tip": "Private notes will only be visible to ApplyBoard users and owner RPs"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-info-circle"
  })), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "restricted-note"
  }))), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1,
    mt: 1,
    mr: 1,
    style: {
      visibility: userPermissions !== null && userPermissions !== void 0 && userPermissions.create_note_attachment || isAgencyAdminComments ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React.createElement(UploadButton, {
    multiple: true,
    name: "new-note-files",
    onFiles: handleOnFiles,
    secondary: true,
    toolTipText: "Upload attachments",
    dataTestId: "upload-button"
  })), /*#__PURE__*/React.createElement(DisableOnLoading, {
    loading: newNoteLoading
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 1,
    alignSelf: "flex-end"
  }, /*#__PURE__*/React.createElement(SimpleButton, {
    buttonColor: "grey",
    buttonHeight: BUTTON_HEIGHT,
    buttonHover: "hoverGrey",
    buttonWidth: BUTTON_WIDTH,
    disabled: !!newNoteLoading,
    onClick: handleOnCancel
  }, "Cancel"), /*#__PURE__*/React.createElement(SimpleButton, {
    buttonColor: "blue",
    buttonHeight: BUTTON_HEIGHT,
    buttonHover: "hoverBlue",
    buttonWidth: BUTTON_WIDTH,
    disabled: !!newNoteLoading,
    marginLeft: "10px",
    onClick: function onClick(clickEvent) {
      trackEvent({
        event: "Single Application - ".concat(note.visibility === 'private' ? 'Admin Comments' : 'Notes', " - Clicked Create")
      });
      handleOnSave(clickEvent);
    }
  }, "Create"))))), newNoteLoading && /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    "data-testId": "progress-bar"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    progress: newNoteLoading.percentage
  })), ((userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_note_attachment) || isAgencyAdminComments) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileListing, {
    dataTestId: "file-listing",
    files: note.files,
    removeFile: isAgencyAdminComments && onRemoveFile || removeFile
  }), /*#__PURE__*/React.createElement(DropzoneOverlay, {
    dragging: dropzoneDragging,
    hovering: dropzoneHovering
  })), /*#__PURE__*/React.createElement("div", {
    id: "note-templates-modal-container"
  }));
};
var NewNoteDropZone = dropzoneEnhancer(NewNote);
var NewNoteComponent = function NewNoteComponent(props) {
  var onChangeHandler = props.onChangeHandler,
    note = props.note,
    addFile = props.addFile;
  var onDrop = function onDrop(files) {
    if (onChangeHandler) {
      onChangeHandler(note);
    }
    files.forEach(function (file) {
      return addFile(file);
    });
  };
  return /*#__PURE__*/React.createElement(NewNoteDropZone, _extends({}, props, {
    onDrop: onDrop
  }));
};
export default NewNoteComponent;